<template>
<input name="search-craft" id="csearch" placeholder="Найти блок" autocomplete="off" @input="input">
</template>

<script>
export default {
  name: 'MineCraftSearch',
  data() {
    return {
  }},
  methods: {
    input(event) {
      this.$parent.search(event.target.value)
    },
  }
}
</script>


